import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/order/descending.js
// module id = 1617
// module chunks = 0